// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/index.less
// module id = SPU+
// module chunks = 111